// WordPress dependencies
import { Panel } from '@wordpress/components';

// Internal dependencies
import OverlayStylesTab from '../panels/OverlayStylesTab';
import HandleStylesTab from '../panels/HandleStylesTab';
import DividerStylesTab from '../panels/DividerStylesTab';
import LabelStylesTab from '../panels/LabelStylesTab';

export default ( props ) => (
	<Panel>
		{ props.attributes.show_overlay && <OverlayStylesTab { ...props } /> }
		<HandleStylesTab { ...props } />
		{ ! [ 'style01', 'style07' ].includes( props.attributes.slider_template ) && <DividerStylesTab { ...props } /> }
		{ props.attributes.show_labels && <LabelStylesTab { ...props } /> }
	</Panel>
);
